import { z } from 'zod/v3';

export const CloudProviderSchema = z.enum(['aws', 'gcp', 'azure', 'cloudflare', 'aliyun', 'tencent']);

export const CloudResourceUsageStateSchema = z.enum([
  'USED',
  'NOT_USED',
  'UNKNOWN',
]);
export const CloudResourceUsageSchema = z.record(CloudResourceUsageStateSchema);
export const CloudResourceUsageMetadataSchema = z.record(
  z.object({
    source: z.enum(['USER', 'SCAN']),
    updatedAt: z.string(),
    userId: z.string().nullable().optional(),
    runId: z.string().optional(),
  }).strict(),
);

export const ProviderServiceDTOSchema = z.object({
  id: z.string(),
  label: z.string(),
  description: z.string(),
  relevance: z.enum(['essential', 'common', 'optional']),
  recommendedByDefault: z.boolean().optional(),
  testCount: z.number().int().nonnegative(),
}).strict();

export const CloudConnectionAccountDTOSchema = z.object({
  connectionId: z.string().nullable(),
  scanConnectionId: z.string(),
  label: z.string(),
  status: z.string(),
  configSummary: z.record(z.unknown()),
  resourceUsage: CloudResourceUsageSchema,
  resourceUsageMetadata: CloudResourceUsageMetadataSchema,
  resourceUsageDetectionApplied: z.boolean().optional(),
  resourceUsageDetectionJobId: z.string().nullable().optional(),
  resourceUsageDetectionResult: CloudResourceUsageSchema.nullable().optional(),
  resourceUsageDetectionState: z.enum([
    'waiting',
    'active',
    'delayed',
    'completed',
    'failed',
  ]).nullable(),
}).strict();

export const CloudConnectionDTOSchema = z.object({
  provider: CloudProviderSchema,
  connected: z.boolean(),
  integrationId: z.string().nullable(),
  connectionId: z.string().nullable(),
  hasConfig: z.boolean(),
  configSummary: z.record(z.unknown()),
  accounts: z.array(CloudConnectionAccountDTOSchema),
  lastTestedAt: z.string().nullable(),
  lastTestStatus: z.string().nullable(),
  lastScanAt: z.string().nullable(),
  lastScanSummary: z.record(z.unknown()).nullable(),
}).strict();

export const CloudConnectionsDTOSchema = z.array(CloudConnectionDTOSchema);

export type CloudProvider = z.infer<typeof CloudProviderSchema>;
export type CloudResourceUsage = z.infer<typeof CloudResourceUsageSchema>;
export type CloudResourceUsageMetadata = z.infer<
  typeof CloudResourceUsageMetadataSchema
>;
export type ProviderServiceDTO = z.infer<typeof ProviderServiceDTOSchema>;
export type CloudConnectionAccountDTO = z.infer<
  typeof CloudConnectionAccountDTOSchema
>;
export type CloudConnectionDTO = z.infer<typeof CloudConnectionDTOSchema>;
